// 서사 축의 막(act). 인생을 3막으로 나눈다. 나이 경계는 게임 수치이며 고서 근거가 없다.
// 설계: docs/superpowers/specs/2026-10-19-saju-story-linkage-design.md 5절

export const ACT_AGES = Object.freeze([[15, 29], [30, 49], [50, Infinity]]);

/** 나이의 막 번호(1~3). 15세 미만은 null. */
export function actOf(age) {
  if (!Number.isFinite(age) || age < ACT_AGES[0][0]) return null;
  return ACT_AGES.findIndex(([from, to]) => age >= from && age <= to) + 1;
}
